import { render, staticRenderFns } from "./defaultOrderSummary.vue?vue&type=template&id=08b74212&"
import script from "./defaultOrderSummary.vue?vue&type=script&lang=js&"
export * from "./defaultOrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports